import { render, staticRenderFns } from "./PaymentTickets.vue?vue&type=template&id=12d9bf1a&"
import script from "./PaymentTickets.vue?vue&type=script&lang=js&"
export * from "./PaymentTickets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports